import type { AuthorArchiveAuthor, CapiAuthorArchive } from 'types/capi/news';

import Breadcrumbs from '~/components/BreadCrumbs';
import Image from '~/components/Image';
import usePageData from '~/hooks/usePageData';
import useRegion from '~/hooks/useRegion';
import Pagination from '~/routes/plps/components/Products/Pagination';

import {
  ArticleFeedList,
  FEED_MODULE_TYPES,
  StructuredData
} from '../feed/NewsFeedView';

export default function AuthorArchiveView() {
  const region = useRegion();
  const { _schemas, author, features, pagination } =
    usePageData<CapiAuthorArchive>();

  return (
    <div className="content-width mb-12 mt-6 flex flex-col gap-8">
      {_schemas ? <StructuredData schemas={_schemas} /> : null}
      <div className="self-center">
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Home', path: '/' },
            { label: 'News', path: '/news/' },
            { label: 'Authors' }
          ]}
        />
      </div>
      <AuthorHeader author={author} />
      {features.length ? <hr /> : null}
      <ArticleFeedList
        features={features}
        moduleType={FEED_MODULE_TYPES.authorArchive}
        region={region}
      />
      {pagination.pages ? <Pagination pagination={pagination} /> : null}
    </div>
  );
}

function AuthorHeader({ author }: { author: AuthorArchiveAuthor }) {
  return (
    <div className="flex flex-col items-center gap-3 self-center text-center">
      <Image
        className="size-24 rounded-full object-cover"
        alt={author.name}
        src={author.avatar}
        pad={false}
        quality={100}
        loading="lazy"
        responsiveOptions={{ xs: { width: 200 } }}
      />
      <div className="flex flex-col">
        <p className="text-title-md">{author.name}</p>
        {author.title ? (
          <p className="text-sm text-light-grey">{author.title}</p>
        ) : null}
      </div>
      {author.biography ? (
        <p className="max-w-2xl text-sm">{author.biography}</p>
      ) : null}
    </div>
  );
}
